"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditRiskAssessmentsRef = void 0;
const Field_type_1 = require("../../types/Field.type");
exports.CreditRiskAssessmentsRef = {
    priority: Number.MAX_VALUE,
    label: 'fields.enm.credit_risk_assessments.label',
    fallbackLabel: 'Credit risk assessments',
    type: Field_type_1.FieldType.Enum,
    options: [
        { key: 'SOLVENCY_STATUS', label: 'fields.enm.credit_risk_assessments.options.SOLVENCY_STATUS', fallbackLabel: 'Solvency status change' },
        { key: 'MAJOR_NEWS_MEDIA', label: 'fields.enm.credit_risk_assessments.options.MAJOR_NEWS_MEDIA', fallbackLabel: 'Major news media update' },
        { key: 'ORDER_FULFILLMENT_TREND', label: 'fields.enm.credit_risk_assessments.options.ORDER_FULFILLMENT_TREND', fallbackLabel: 'Order fulfillment trend change' },
        { key: 'OTHER', label: 'fields.enm.credit_risk_assessments.options.OTHER', fallbackLabel: 'Any other specific events' },
        { key: 'NOT_TRIGGERED', label: 'fields.enm.credit_risk_assessments.options.NOT_TRIGGERED', fallbackLabel: 'Our credit risk assessments are not triggered by specific events.' },
    ],
    trackFieldValueWithAnalytics: false,
};
